import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Comics from "../pages/comics/page";
import ComicDetail from "../pages/comic/page";
import Rank from "../pages/rank/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "comics", element: <Comics /> },
      { path: "comic/:id", element: <ComicDetail /> },
      { path: "rank", element: <Rank /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;